import type { RouteObject } from 'react-router';
import MainLayout from '~/ui/layout/MainLayout';
import { DemoFlowPage } from '~/pages/demo/DemoFlowPage';
import { BookingConfirmationPage } from '~/pages/booking/BookingConfirmationPage';
import { BookingProvider } from '~/services/internalApi/booking';

/**
 * Demo Booking Routes (S3)
 *
 * /demo               — the member demo booking flow. No PERSISTENT nav links
 *                       point here by design: admins deep-link it for
 *                       campaigns, and the required-demo rule (S4, D39/D40)
 *                       lands gated members on it — the booking grid's
 *                       demo-restriction banner and the purchase-confirmation
 *                       CTA are its in-product entrances.
 * /demo/confirmed/:id — the demo variant of the shared confirmation page.
 *
 * Domain-first like /subscriptions; instructor/lesson flows will follow the
 * same pattern. Mounted inside WaiverGate (a demo is bay time — signed-in
 * members must be current on waivers; guests sign in the finish step).
 *
 * `persist={false}`: demo selections must not leak into the standard flow's
 * restored sessionStorage state (a fixed 30-min demo range is invalid there),
 * and there's no payment redirect to survive.
 */
export const demoRoutes: RouteObject[] = [
  {
    path: '/demo',
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: (
          <BookingProvider persist={false}>
            <DemoFlowPage />
          </BookingProvider>
        ),
      },
      {
        path: 'confirmed/:bookingId',
        element: <BookingConfirmationPage variant="demo" />,
      },
    ],
  },
];
